import React from "react";
import { Link } from "react-router-dom";
import Layout from "@/components/Layout";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Plus, ListChecks } from "lucide-react";
import OfficerComplaints from "@/pages/OfficerComplaints";

export function ControlRoomHome() {
  return (
    <Layout>
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-8">
        <div className="mb-6 flex items-center justify-between flex-wrap gap-3">
          <div>
            <div className="overline text-slate-500">Police Control Room</div>
            <h1 className="font-display font-bold text-3xl tracking-tight">Command &amp; dispatch</h1>
            <p className="text-slate-600 text-sm mt-1">Register complaints on behalf of citizens and reassign to the correct police station.</p>
          </div>
          <Link to="/control-room/register">
            <Button className="gap-2" data-testid="cr-register-cta"><Plus className="w-4 h-4" /> Register new complaint</Button>
          </Link>
        </div>
        <Card className="mb-4">
          <CardContent className="py-5 flex items-center gap-4">
            <ListChecks className="w-5 h-5 text-slate-500" />
            <div className="text-sm text-slate-700">Every complaint filed by any citizen or officer is shown below. Use <b>Reassign</b> to move a complaint to a different Police Station if it was routed incorrectly.</div>
          </CardContent>
        </Card>
      </div>
      <OfficerComplaints scope="control_room" />
    </Layout>
  );
}
